import { render, staticRenderFns } from "./NewsSlider.vue?vue&type=template&id=7c28c569&lang=pug&"
import script from "./NewsSlider.vue?vue&type=script&lang=js&"
export * from "./NewsSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports